import React, { useEffect, useState } from "react";
import FormInputField from "../../components/global/FormTextInput/FormInputField";
import Checkbox from "../../components/global/Checkbox/Checkbox";
import {
  GetFileSummaryExpress,
  GetSystemVariableValue,
  orderSliceSelector,
} from "../../features/orders/orderSlice";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { saveNote } from "../../features/notes/notesSlice";
import { GetDocStoreDetails, orderSummarySelector } from "../../features/ordersSummary/orderSummarySlice";

const SendDocuments = ({
  t,
  register,
  formValues,
  handleChange,
  handleChangeCheckbox,
  errors,
  ccDetails,
  loading,
  dispatch,
  SendEmailForSendPolicyDocumentExpress,
  EmailValid,
  fileID,
  userID,
  setValue
}) => {

  const { fileSummaryDetails, systemVariableValue } = useSelector(orderSliceSelector);
  const { DocStoreDetails } = useSelector(orderSummarySelector);
  const [laywerEmailContact, setlaywerEmailContact] = useState(null);
  const [orderingLawyerEmailContact, setorderingLawyerEmailContact] =
    useState(null);
  const [firmName, setfirmName] = useState("");
  const [selectContactValid, setselectContactValid] = useState(true);
  const [EmailPolicy, setEmailPolicy] = useState(false);
  const [Documents, setDocuments] = useState([]);

  useEffect(() => {
    if (fileSummaryDetails === null) {
      dispatch(GetFileSummaryExpress(fileID, userID));
    } else {
      if (
        fileSummaryDetails?.lawyerEmail !== null &&
        fileSummaryDetails?.lawyerEmail !== "" &&
        fileSummaryDetails?.lawyerName !== ""
      ) {
        setlaywerEmailContact({
          lawyerName: fileSummaryDetails?.lawyerName,
          lawyeremail: fileSummaryDetails?.lawyerEmail,
        });
      }
      if (
        fileSummaryDetails?.orderingLawyerEmail !== null &&
        fileSummaryDetails?.orderingLawyerEmail !== "" &&
        fileSummaryDetails?.orderingLawyerName !== ""
      ) {
        setorderingLawyerEmailContact({
          orderinglawyerName: fileSummaryDetails?.orderingLawyerName,
          orderinglawyeremail: fileSummaryDetails?.orderingLawyerEmail,
        });
      }
      if (
        fileSummaryDetails?.firmName !== null &&
        fileSummaryDetails?.firmName !== ""
      ) {
        setfirmName(fileSummaryDetails?.firmName);
      }
    }

  }, [fileSummaryDetails]);

  useEffect(() => {
    if (EmailPolicy) {
      dispatch(GetSystemVariableValue("NoReplyEmailuserID"));
      dispatch(GetDocStoreDetails(fileID, userID));
    }
  }, [EmailPolicy]);

  useEffect(() => {
    setDocuments(DocStoreDetails?.DocStore?.filter(x => x?.documentType?.toLowerCase() === "owner policy" || x?.documentType?.toLowerCase() === "lender policy" || x?.documentType?.toLowerCase() === "loan policy"));
  }, [EmailPolicy, DocStoreDetails])

  useEffect(() => {
    if (EmailPolicy) {
      //bydefault check the checkbox
      Documents?.forEach((elements, index) => {
        setValue(`sendDoc_${elements?.storageFileID}`, true);
      })
    }
  }, [Documents])

  return (
    <div>
      <ToastContainer />
      <div className="flex">
        <button className="btn__primary px-[16px] py-[9px] mt-12 mb-12"
          onClick={() => setEmailPolicy(true)}
        >
          {t("emailPolicy")}
        </button>
        {/* email policy section */}
        {EmailPolicy &&
          <dialog
            id="delete_dialog2"
            className="modal"
            open
          >
            <div id="emailPolicySection" className="modal-content w-auto" style={{ maxHeight: "80%", overflowY: "scroll", overflowX: "hidden" }}>
              <div className="float-right">
                <span onClick={() => { setEmailPolicy(false); setselectContactValid(true); }}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    x='0px'
                    y='0px'
                    width='15'
                    height='15'
                    viewBox='0 0 50 50'
                  >
                    <path d='M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z'></path>
                  </svg>
                </span>

              </div>
              <div className="mt-8 ml-3 w-100">
                <table className="border rounded">
                  <thead className="">
                    <tr className="bg-gray-200 border rounded font-semibold leading-[27.24px]">
                      <th className="pl-2">{t('Send')}</th>
                      <th className="w-[388px]">{t('Document')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Documents?.map((item, index) => {
                      return (
                        <tr className="border rounded w-[388px]">
                          <td className="border rounded pl-0">
                            <Checkbox
                              register={register}
                              name={`sendDoc_${item?.storageFileID}`}
                              classNames={`w-[15px]`}
                              onChange={handleChangeCheckbox}
                              checked={formValues[`sendDoc_${item?.storageFileID}`] || false}
                            />
                          </td>
                          <td className="text-left pl-2 pr-2"> {item?.filename}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="ml-2">
                <div className="font-semibold font-open-sans leading-[27.24px] text-start  mt-5 ml-1">
                  {t('Contact')}
                </div>

                <div className="font-semibold font-open-sans leading-[27.24px]">
                  <table>
                    {laywerEmailContact?.lawyeremail !== null && (
                      <tr>
                        <Checkbox
                          register={register}
                          name={`lawyercontact`}
                          classNames={`w-max`}
                          onChange={handleChangeCheckbox}
                          checked={formValues?.lawyercontact || false}
                          label={`${t("LawyerOrNotaryOfRecord")}: ${laywerEmailContact?.lawyerName} -- ${firmName}`}

                        //disabled={disableWhenSave !== index && disableWhenSave !== -1}
                        />
                      </tr>
                    )}
                    {orderingLawyerEmailContact?.orderinglawyerEmail !== null && (
                      <tr>
                        <Checkbox
                          register={register}
                          name={`Orderinglawyercontact`}
                          classNames={`w-max`}
                          onChange={handleChangeCheckbox}
                          checked={formValues?.Orderinglawyercontact || false}
                          label={`${t('OrderingLawyerOrNotary')}: ${orderingLawyerEmailContact?.orderinglawyerName} -- ${firmName}`}
                        />
                      </tr>
                    )}
                  </table>
                </div>
                <div>
                  <div className="flex flex-col">
                    <div className="inline-flex flex flex-row  space-x-4 mt-4">
                      <FormInputField
                        fieldName="NewEmail"
                        type="text"
                        id="NewEmail"
                        testId="NewEmail"
                        // register={{...register('NewEmail')}}
                        register={register}
                        label={t("NewEmail")}
                        handleChange={handleChange}
                        //placeholder={t("NewEmail")}
                        inputClassnames="w-[400px] text-neutrals-black"
                        labelClasses="questionnaire font-semibold w-auto mt-2"
                        mainClassnames="border-box-stroke text-gray-900 text-sm rounded-sm block w-full p-2.5 hover:border-placeholder hover:background-[#FAFAFA] 
                        focus:border-placeholder focus:bg-neutral-50 focus:ring-transparent"
                        disabled={loading}
                        value={formValues?.NewEmail}
                      />
                    </div>
                    <div className="font-semibold text-secondary-red flex flex-row pt-2">
                      {!EmailValid &&
                        formValues?.NewEmail?.length > 0 &&
                        t('SendNewEmailError')}
                    </div>
                  </div>
                </div>

                <div>
                  <div className="mb-0">
                    <button
                      className="btn__primary px-[16px] py-[9px] mt-8 mb-4 mr-8"
                      onClick={() => {
                        let emailArray = [];
                        if (formValues?.lawyercontact && laywerEmailContact?.lawyeremail) {
                          emailArray.push(laywerEmailContact?.lawyeremail);
                          setselectContactValid(true);
                        }
                        if (formValues?.Orderinglawyercontact && orderingLawyerEmailContact?.orderinglawyeremail) {
                          emailArray.push(orderingLawyerEmailContact?.orderinglawyeremail);
                          setselectContactValid(true);

                        }
                        if (formValues?.NewEmail && formValues?.NewEmail !== "" && EmailValid) {
                          emailArray.push(formValues?.NewEmail);
                          setselectContactValid(true);

                        }
                        if (formValues?.NewEmail !== "" && !EmailValid) {
                          setselectContactValid(true);
                          return;
                        }
                        if ((formValues?.NewEmail === "" || formValues?.NewEmail === undefined) && !formValues?.lawyercontact && !formValues?.Orderinglawyercontact) {
                          setselectContactValid(false);
                          return;
                        }
                        setEmailPolicy(false);
                        let request = {
                          UserID: parseInt(systemVariableValue?.variableValue ? systemVariableValue?.variableValue : userID),
                          Emailvalue: emailArray,
                          FileID: fileID,
                          EmailDoclist: Object.keys(formValues)
                            .filter((key) => key.startsWith('sendDoc_') && formValues[key])
                            .map((key) => key.replace('sendDoc_', '')),
                          isHtml: false
                        };
                        //--QA docgen server not allowing to send to outside email server like gmail
                        dispatch(SendEmailForSendPolicyDocumentExpress(request, { toast }));
                        dispatch(
                          saveNote(
                            fileID,
                            "Policy issued and forwarded to : " + emailArray.join(";"),
                            userID,
                            -1,
                            null,
                            "PoliciesEmailed",
                            false
                          )
                        );
                      }}
                    >
                      {t("SendDocument(s)")}
                    </button>
                    <button className="btn__primary px-[16px] py-[9px] mt-8 mb-4"
                      onClick={() => { setEmailPolicy(false); setselectContactValid(true); }}
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                  <div>
                    {!selectContactValid &&
                      <span className="font-semibold text-secondary-red">
                        {t("SelectContactError")}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </dialog>
        }
      </div>
    </div>
  );
};

export default SendDocuments;
